import { SsrFlowExitReason } from '../../../models/monitoring/SsrFlowExitReason';
import { SsrActionType } from '../../../models/monitoring/SsrActionType';
import { RootState } from '../../../state/state';

export const ssrMetricsFeatureKey = 'ssrMetrics';

export interface State extends RootState {
  ssrMetrics: SsrMetrics;
}

export interface SsrMetrics {
  actionType?: SsrActionType;
  exitReason?: SsrFlowExitReason;
  startTimestampMillis?: number;
  ssrCode?: string;
  confirmationCode?: string;
}

export const initialSsrMetricsState: SsrMetrics = {
  actionType: undefined,
  exitReason: undefined,
  startTimestampMillis: undefined,
  ssrCode: undefined,
  confirmationCode: undefined,
};
